import HttpClientToken from '../../services/HttpClientToken';
import HttpClientFileToken from '../../services/HttpClientFileToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { BuscarLibroSentenciaInterlocutoriaParams, BuscarLibroSentenciaInterlocutoriaResponse, defaultBuscarLibroSentenciaInterlocutoriaResponse, DescargarInformacionParams, GuardarObservaciones } from '../../interfaces/libros-electronicos/LibroSentenciaInterlocutoriaInterface';

export const ObtenerLibroSentenciaInterlocutoria = ( params: BuscarLibroSentenciaInterlocutoriaParams ) => {

    return new Promise<BuscarLibroSentenciaInterlocutoriaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if ( data ) {

            const { token } = data;

            HttpClientToken.post('/Api/LibroSentenciaInterlocutoria/ObtenerLibroSentenciaInterlocutoria', params, token)
            .then(({ data }: { data: BuscarLibroSentenciaInterlocutoriaResponse }) => {
                resolve(data);
            })
            .catch( () => {
                resolve({ ...defaultBuscarLibroSentenciaInterlocutoriaResponse });
            });

        }

    });

}

export const GuardarObservacionesLibroSentenciaInterlocutoria = ( params: GuardarObservaciones ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/LibroSentenciaInterlocutoria/GuardarObservaciones', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const DescargarLibroSentenciaInterlocutoria = ( params: DescargarInformacionParams ) => {

    return new Promise<Blob | null>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientFileToken.post('/Api/LibroSentenciaInterlocutoria/DescargarInformacion', params, token)
            .then( ({ data } : { data : Blob } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( null );
            });

        }

    });

}
